
/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';
import { VersionStrategy } from './OrganisationType';

export const FLOW_DEF_VERSION_ID_DEVELOPMENT = "00000000-0000-0000-0000-000000000000";
export const FLOW_DEF_VERSION_ID_STABLE = "$stable";

export default declareEntity({
    entity: "flowDefVersions",
    graphQL: "FlowDefVersion",
    name: "Flow Definition Version",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    optimizeReading: true,
    defaultOrder: [['createdAt', 'DESC']],
    fields: (types) => { return {
        id: {
            name: "Flow Definition Version ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            isPublic: true,
            required: true,
            userEditable: false,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            hiddenCreate: true,
        },
        inChangeLog: {
            name: "In Change Log",
            type: "enum",
            defaultValue: "-",
            filterable: true,
            values: {
                "-": {
                    name: "Not decided yet",
                },
                "yes": {
                    name: "Yes",
                },
                "no": {
                    name: "No",
                },
            },
        },
        upgradeStatus: {
            name: "Upgrade Status",
            type: "enum",
            filterable: true,
            defaultValue: "auto",
            values: {
                "auto": {
                    name: "Auto upgrade",
                },
                "critical-auto": {
                    name: "Forced auto upgrade (contains critical fix)",
                },
                "no-auto": {
                    name: "No auto upgrade",
                },
                "no-manual": {
                    name: "Upgrade not recommended (may contain a bug)",
                },
                "has-bug": {
                    name: "Do not upgrade (contains bug)",
                },
            },
        },
        fixesBugFromVersion: {
            name: "Fixes bug from version",
            type: "relation",
            to: () => types['flowDefVersions'],
            defaultValue: "",
        },
        popularity: {
            name: "Popularity",
            type: "int",
            isPublic: true,
            defaultValue: 0,
            import: false,
            export: false,
        },
        isPublished: {
            name: "Is published",
            type: "boolean",
            defaultValue: false,
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        title: {
            name: "Change Title",
            type: "string",
            defaultValue: "",
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        changeType: {
            name: "Change Type",
            type: "enum",
            values: {
                "feature": {
                    name: "Feature",
                },
                "improvement": {
                    name: "Improvement",
                },
                "bug": {
                    name: "Bug fix",
                },
                "critical-bug": {
                    name: "Critical bug fix",
                },
                "other": {
                    name: "Other",
                },
            },
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        description: {
            name: "Change Description",
            type: "text",
            defaultValue: "",
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        commitDescription: {
            name: "Commit Description",
            type: "text",
            defaultValue: "",
        },
        marketingImpact: {
            name: "Marketing Impact",
            type: "string",
            defaultValue: "",
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        partnersImpact: {
            name: "Partners Impact",
            type: "string",
            defaultValue: "",
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        gitTag: {
            name: "Git sha",
            type: "string",
        },
        gitAuthorName: {
            name: "Git Author Name",
            type: "string",
        },
        gitAuthorEmail: {
            name: "Git Author e-mail",
            type: "string",
        },
        flowDefContentGit: {
            name: "Content (GIT)",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            offload: true,
            import: false,
            userEditable: false,
        },
        flowDefContent: {
            name: "Content",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            import: false,
            offload: true,
            userEditable: false,
        },
        groupDefsContent: {
            name: "Group Definition Content",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            offload: true,
            import: false,
            userEditable: false,
        },
        channelDefsContent: {
            name: "Application Definition Content",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            offload: true,
            import: false,
            userEditable: false,
        },
        strategy: {
            name: "Strategy",
            type: "enum",
            values: VersionStrategy,
            userEditable: false,
            import: false,
            export: false,
            controllerFn: "getStrategy",
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        ticketUrl: {
            name: "Ticket URL",
            type: "url",
            defaultValue: "",
        },
        changeAuthor: {
            name: "Last change author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: () => { return {
    }; }
});
